<mat-progress-bar *ngIf="showNotificationLoader" mode="indeterminate"></mat-progress-bar>

<!-- <p class="fs-18 bold my-16 px-24">Notifications</p> -->

<div>
    <div class="notification-header">
        <button mat-icon-button (click)="closeSidePanel()" class="back-btn">
            <mat-icon>arrow_forward</mat-icon>
        </button>
        <div class="fs-18 bold pr-8">{{'NOTIFICATIONS' | translate}}</div>
    </div>

    <div class="notification-wrapper h-100-p" id="notification-container">

        <div class="notification-body h-100-p pt-20 pb-20 ">
            <!-- shows notifications -->
            <div *ngIf="notifications && notifications.length">
                <div fxLayout="row" fxLayoutGap="4px">
                    <button fxFlex="50" class="mb-16 w-100-p project-btn py-12 cursor-pointer"
                        (click)="onMarkAllAsRead()">
                        {{ 'MARK_ALL_AS_READ' | translate }}
                    </button>
                    <button fxFlex="50" class="mb-16 w-100-p project-btn py-12 cursor-pointer"
                        (click)="onDeleteAllReadClick()">{{'DELETE_ALL_READ' | translate}}</button>
                </div>
                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px" class="notification"
                    *ngFor="let notification of notifications"
                    (click)="$event.preventDefault(); notificationClicked(notification)"
                    (keyDown)="handleKeyDown($event)">
                    <div fxFlex="10" fxLayoutAlign="center center">
                        <img src="../../../../../assets/icons/notificationBell.png" alt="Bell Icon" />
                    </div>
                    <div fxFlex="65" fxLayoutAlign="left center">
                        <ng-container class="notification-body-txt" *ngTemplateOutlet="
                                notificationBody;
                                context: { $implicit: notification }
                            "></ng-container>
                    </div>
                    <div fxFlex fxLayoutAlign="end end">
                        <div fxLayout="column">
                            <div [hidden]="notification?.IsRead" fxFlex="100" class="dot_ico">
                                <img src="../../../../../assets/icons/ellipseUnread.png" alt="Unread Icon" />
                            </div>
                            <div fxFlex="100" class="delete-icon">
                                <mat-icon mat-icon-button class="delete-icon"
                                    (click)="$event.stopPropagation(); onSingleDeleteClick(notification.Id)"
                                    (keyDown)="handleKeyDown($event)">delete</mat-icon>
                            </div>
                        </div>
                    </div>
                    <div class="time-diff-corner">
                        <div *ngIf="notification?.TimeDiffStr?.length > 0">
                            <p class="time-diff-txt">{{ notification?.TimeDiffStr }}</p>
                        </div>
                        <div *ngIf="notification?.TimeDiffStr?.length == 0">
                            <p class="time-diff-txt" *ngIf="notification.CreatedTime">
                                {{ notification.CreatedTime | date: 'mediumDate' | uppercase }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- <p
                    *ngIf="totalRecord && totalRecord > loadedData"
                    class="link-type"
                    (click)="loadMore()"
                >
                    Load more...
                </p> -->
                <button *ngIf="totalRecord && totalRecord > loadedData" class="
                        upcoming-project
                        w-100-p
                        project-btn
                        py-12
                        cursor-pointer
                    " (click)="loadMore()">
                    {{ 'LOAD_MORE' | translate }}
                </button>
            </div>
            <!-- if no notificaiton found -->
            <div *ngIf="
                    !showNotificationLoader &&
                    notifications &&
                    !notifications.length
                " fxLayout="row" fxLayoutAlign="center center">
                <span>{{ 'NO_DATA_TO_DISPLAY' | translate }}</span>
            </div>
            <!-- if notification length gets higher -->
            <!-- <div class="all-notification" *ngIf="notifications && notifications.length && (displayingNotificationcount < totalNotification )">
                <button mat-button mat-raised-button class="w-100-p pt-8 pb-8 legacy-bold" (click)="gotoBot()">{{'QUICK_PANEL.VIEW_ALL'| translate}}</button>
            </div> -->
        </div>
    </div>
</div>

<ng-template #notificationBody let-notification>
    <div class="single-notification-body abcd" *ngIf="
            (notification.DenormalizedPayload &&
                notification.DenormalizedPayload.MessageKey &&
                !notification.DenormalizedPayload.MessageKey.includes(
                    'ProjectArchived'
                ) &&
                !notification.DenormalizedPayload.MessageKey.includes(
                    'EmployeeReplacedFromProject'
                )) ||
            (notification.DenormalizedPayload.message &&
                !notification.DenormalizedPayload.message.includes(
                    'LeaveRequest'
                ))
        ">
        <!-- <p
            *ngIf="
                notification.Payload?.ResponseKey ===
                'SuccessfullyGeneratedPayslips'
            "
            class="
                p-0
                m-0
                font-size-16
                line-height-24
                word-break
                noification-msg
            "
        > -->
        <p *ngIf="
                notification.Payload?.ResponseKey ===
                    'SuccessfullyCalculatedMonthlyPayroll' ||
                notification.Payload?.ResponseKey ===
                    'FailedCalculationMonthlyPayroll' ||
                notification.Payload?.ResponseKey ===
                    'OpenPositionRequestSuccessful' ||
                notification.Payload?.ResponseKey === 'ApprovedLeaveCancelled' || 
                notification.Payload?.ResponseKey === 'AssignSubOnsiteLeader' ||
                notification.Payload?.ResponseKey === 'AcceptOrRejectLeaveRequest' ||
                notification.Payload?.ResponseKey === 'AddedOrRemovedLeave' ||
                notification.Payload?.ResponseKey === 'EmployeeReservation' ||
                notification.Payload?.ResponseKey === 'LeaveRequestReminder' ||
                notification.Payload?.ResponseKey === 'LeaveRequestLastDayReminder' ||
                notification.Payload?.ResponseKey === 'TimeInputReminder' ||
                notification.Payload?.ResponseKey === 'VehiclePlanNotificationSent' ||
                notification.Payload?.ResponseKey === 'AssignedToVehicle'||
                notification.Payload?.ResponseKey === 'RemovedFromVehicle' ||
                notification.Payload?.ResponseKey === 'InventoryTransactionRequest' ||
                notification.Payload?.ResponseKey === 'SuccessfullyGeneratedPayslips' ||
                notification.Payload?.ResponseKey === 'AnnouncementCreatedSuccessfully' ||
                notification.Payload?.ResponseKey === 'LeaveRequestNotifaction' ||
                notification.Payload?.ResponseKey === 'WishlistDeadlineExpired' ||
                notification.Payload?.ResponseKey === 'EmployeeWishListSent' ||
                notification.Payload?.ResponseKey === 'EmployeeWishListSentSingleProject' ||
                notification.Payload?.ResponseKey === 'ProjectInformationChange' ||
                notification.Payload?.ResponseKey === 'ProjectDescriptionChange' ||
                notification.Payload?.ResponseKey === 'AssignedOnsiteLeader' ||
                notification.Payload?.ResponseKey === 'AssignedLogisticPerson' ||
                notification.Payload?.ResponseKey === 'StandingRemoval' ||
                notification.Payload?.ResponseKey === 'ThreadRecipientsUpdated' ||
                notification.Payload?.ResponseKey === 'PayslipUpdated' ||
                notification.Payload?.ResponseKey === 'QualityReportCreated' ||
	            notification.Payload?.ResponseKey === 'WishlistAcceptingExpirationReminder' ||
                notification.Payload?.ResponseKey === 'AnnouncementByRoleCreatedSuccessfully' ||
                notification.Payload?.ResponseKey === 'ProjectExpirationNotification'
            " class="
                p-0
                m-0
                word-break
                noification-msg
            ">
            <span>{{ notification.DenormalizedPayload.MessageKey }}</span>
        </p>
        <p *ngIf="
                notification.Payload?.ResponseKey === 'ProjectInfoUpdatedSuccessfully' ||
                notification.Payload?.ResponseKey === 'DocumentUpdatedInProject' ||
                notification.Payload?.ResponseKey === 'NotifyAboutBookingSuccessfully' ||
                notification.Payload.ResponseKey === 'EmployeeBooking' ||
                notification.Payload.ResponseKey === 'OpenPositionRequested' ||
                notification.Payload.ResponseKey === 'EORTPlaceUpdated' ||
                notification.Payload.ResponseKey === 'ProjectManpowerScheduleChanged' ||
                notification.Payload.ResponseKey === 'ProjectCancelled' ||
                notification.Payload.ResponseKey === 'ProjectGenerated' ||
                notification.Payload.ResponseKey === 'VehiclePlanningIncomplete' ||
                notification.Payload.ResponseKey === 'PickUpTimeAndPlaceUpdated' || 
                notification.Payload.ResponseKey === 'ReserveCancellation' ||
                notification.Payload.ResponseKey === 'AdminApprovalOfProfileChange' ||
                notification.Payload.ResponseKey === 'CommonResponseKey' ||
                notification.Payload.ResponseKey === 'QualityReportReviewed'

            " class="
                p-0
                m-0
                word-break
                noification-msg
            ">
            <span *ngIf="notification.DenormalizedPayload.MessageKey.includes('booked for') 
                                || notification.DenormalizedPayload.MessageKey.includes('EORT'); else noDateSeparated"
                [innerHTML]="notification.DenormalizedPayload.MessageKey | replaceDateSeparator: '.'"></span>
            <ng-template #noDateSeparated>
                <span [innerHTML]="notification.DenormalizedPayload.MessageKey"></span>
            </ng-template>
        </p>

        <p class="font-size-16 p-0 mt-0 mb-4 line-height-16 legacy-bold"
            *ngIf="notification?.DenormalizedPayload?.title">
            {{ notification?.DenormalizedPayload?.titleKey }}
        </p>

        <p class="
                p-0
                m-0
                word-break
                noification-msg
            " *ngIf="notification.DenormalizedPayload.message">
            {{ notification.DenormalizedPayload.message }}<br />
            <!-- <span class="cursor-pointer view-more" (click)="gotoDetails(notification.DetailsInfo)">
        {{'QUICK_PANEL.VIEW_DETAILS'| translate}}</span>
      </p> -->
        </p>
        <p *ngIf="
                notification?.Payload?.ResponseKey === 'projectRequest' ||
                'projectBooked'
            " class="p-0 m-0 font-size-14 line-height-20">
            <span *ngFor="
                    let param of notification?.DenormalizedPayload?.TaskTitle?.split(
                        ','
                    )
                ">
                {{ param }} <br />
            </span>
        </p>
    </div>
    <div class="single-notification-body" *ngIf="
            notification.DenormalizedPayload &&
            notification.DenormalizedPayload.message &&
            notification.DenormalizedPayload.message.includes('LeaveRequest')
        ">
        <div class="
                p-0
                m-0
                word-break
                noification-msg
            ">
            <span>{{
                notification.DenormalizedPayload.message.split('#')[1]
                }}</span>
            &nbsp;<span class="c-gray">has</span> &nbsp;<span class="c-blue">sent</span>
            &nbsp;<span class="c-gray">a</span> &nbsp;<span class="c-red">Leave Request</span>
        </div>
    </div>
    <div class="single-notification-body" *ngIf="
            notification.DenormalizedPayload &&
            notification.DenormalizedPayload.MessageKey &&
            notification.DenormalizedPayload.MessageKey.includes(
                'EmployeeReplacedFromProject'
            )
        ">
        <div class="
                p-0
                m-0
                word-break
                noification-msg
            ">
            {{ 'EMPLOYEE_REPLACED_FROM_PROJECT' | translate }}<br />
            <strong>{{ notification.DenormalizedPayload.MessageKey.split('#')[3] }}
                (
                {{ notification.DenormalizedPayload.MessageKey.split('#')[1] }}
                -
                {{ notification.DenormalizedPayload.MessageKey.split('#')[2] }}
                )</strong>
        </div>
    </div>
    <div class="single-notification-body" *ngIf="
            notification.DenormalizedPayload &&
            notification.DenormalizedPayload.MessageKey &&
            notification.DenormalizedPayload.MessageKey.includes(
                'ProjectArchived'
            )
        ">
        <div class="
                p-0
                m-0
   
                word-break
                noification-msg
            ">
            {{ 'PROJECT_ARCHIVED' | translate }}<br />
            {{ notification.DenormalizedPayload.MessageKey.split('#')[3] }}
            (
            {{ notification.DenormalizedPayload.MessageKey.split('#')[1] }}
            -
            {{ notification.DenormalizedPayload.MessageKey.split('#')[2] }}
            )
        </div>
    </div>
</ng-template>
